import { defineGameCard } from '../authoring/index.js';
export const MindlessSlimeCard = defineGameCard({
    id: 'mindless_slime',
    gameplay: { type: 'UNIT', cost: 0, baseStats: { attack: 1, health: 1 }, traits: ['SLIME'] },
    presentation: {
        name: 'Безвольный слизень',
        description: 'Слизень 1/1 без способностей. След 0.',
        glyph: {
            colors: ['#9B842E', '#10213A', '#B09A3B', '#A68F35', '#A68F35'],
            rows: [
                '....................',
                '....................',
                '....................',
                '....................',
                '............1.....1.',
                '.............1...1..',
                '..............222...',
                '.............23342..',
                '............2423232.',
                '............2333332.',
                '...........23444442.',
                '......222223344112..',
                '....22333434441442..',
                '..2244444444414432..',
                '.2444111111114432...',
                '.2211333333333322...',
                '...222222222222.....',
                '....................',
                '....................',
                '....................',
            ],
        },
    },
    role: 'auxiliary',
    ui: { mechanics: ['trail', 'slime_residue'] },
});
//# sourceMappingURL=mindless_slime.js.map